export function reminderStatusLabel(status: string, deliveryKind: string | null): string {
	return status === 'sent' && deliveryKind === 'record_only' ? 'Recorded — not sent' : status;
}

export function reminderActionConfirmation(
	action: 'cancel' | 'send-now',
	deliveryMode?: 'record_only' | 'provider',
	channel?: 'email' | 'sms',
): string {
	if (action === 'cancel') return 'Reminder cancelled.';
	if (deliveryMode === 'record_only') return 'Reminder queued for recording only. No message will be sent.';
	if (deliveryMode === 'provider' && channel === 'email') return 'Reminder queued for email delivery.';
	return 'Reminder queued.';
}
